import { duration } from "@formant/core/model/duration";

import { RtcChannelLabel } from "../models/RtcChannelLabel";

export const latesTtlStreamLabel: RtcChannelLabel = "stream.latest-ttl";
export const latestTtlStreamConfig: RTCDataChannelInit = {
    ordered: false,
    maxPacketLifeTime: 300 * duration.millisecond,
};

export const reliableStreamLabel: RtcChannelLabel = "stream.reliable";
export const reliableStreamConfig: RTCDataChannelInit = {
    ordered: true,
};

export const latestReliableStreamLabel: RtcChannelLabel =
    "stream.latest-reliable";
export const latestReliableStreamConfig: RTCDataChannelInit = {
    ordered: true,
};

export const latestTryOnceStreamLabel: RtcChannelLabel =
    "stream.latest-try-once";
export const latestTryOnceStreamConfig: RTCDataChannelInit = {
    ordered: false,
    maxRetransmits: 0,
};

export const heartbeatChannelLabel: RtcChannelLabel = "heartbeat";
export const heartbeatChannelConfig: RTCDataChannelInit = {
    ordered: false,
    maxRetransmits: 0,
};
